import type { UseFormGetValues } from "react-hook-form"
import type { PointOfCareFormType } from "@/modules/patients/detail/progress-note/point-of-care/schema"

export const isCareProviderPreselectable = (getValues: UseFormGetValues<PointOfCareFormType>): boolean =>
  !getValues("careProviderId") && !getValues("betterDocSuggestionStatus")
